import * as React from 'react';

import { Portal } from 'components/Portal';

import './LayoutFooter.scss';

export class LayoutFooter extends React.Component<{}, {}> {
  render() {
    return (
      <Portal elementId="layout__footer-extension">
        {this.props.children}
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/LayoutFooter/LayoutFooter.tsx